export default {
  SET_DOMAIN_CONFIG: "SET_DOMAIN_CONFIG"
};